import React from "react";

import "./styles.scss";

interface IProps {
  buttonLabel: string;
  confirmationHeader: string;
  confirmationMessage: string;
  handleCancel: () => void;
  handleConfirm: () => void;
}

export const ConfirmationModal = ({
  buttonLabel,
  confirmationHeader,
  confirmationMessage,
  handleCancel,
  handleConfirm,  
}: IProps) => {
  return (
    <>
      <div className="confirmation-modal">
        <div className="confirmation-header">{ confirmationHeader }</div>
        <div className="confirmation-text">{ confirmationMessage }</div>
        <div className="button-container">
          <button className="btn btn-outline-primary" onClick={handleConfirm} >
              { buttonLabel }
          </button>
          <button className="btn btn-outline-primary" onClick={handleCancel}>
              Cancel
          </button>
        </div>
      </div>
      <div className="confirm-backbround" onClick={handleCancel}></div>
    </>
  );
}